export const LANDING = {
  header: 'landing-header',
  langToggle: 'lang-toggle',
  langLabel: 'lang-label',
  headerPhone: 'header-phone-cta',
  hero: 'hero-section',
  heroTitle: 'hero-title',
  heroSubtitle: 'hero-subtitle',
  heroCta: 'hero-cta-button',
  trustZone: 'trust-zone',
  reraNumber: 'rera-number',
  plotLayout: 'plot-layout-section',
  plotMap: 'plot-map-image',
  plotTable: 'plot-table',
  plotFilter: 'plot-filter',
  infrastructure: 'infrastructure-section',
  locationMatrix: 'location-matrix',
  locationCard: 'location-card',
  stickyFooter: 'sticky-footer',
  ctaWhatsapp: 'cta-whatsapp',
  ctaPhone: 'cta-phone',
  ctaBrochure: 'cta-brochure',
  floatingCta: 'floating-cta',
  marquee: 'editorial-marquee',
  siteVisitForm: 'site-visit-form',
  siteVisitName: 'site-visit-name',
  siteVisitPhone: 'site-visit-phone',
  siteVisitSubmit: 'site-visit-submit',
  siteVisitSuccess: 'site-visit-success',
  brochureModal: 'brochure-modal',
  brochureName: 'brochure-name',
  brochurePhone: 'brochure-phone',
  brochureSubmit: 'brochure-submit',
  emiCalculator: 'emi-calculator',
  emiResult: 'emi-result',
  mapSection: 'map-section',
  mapEmbed: 'google-map-embed',
};
